export enum MESSAGE_QUERY_TYPE {
  OLDER = 'older',
  NEWER = 'newer'
}
